const mac = require('macaddress').one()

export default mac
